var React = require("react");
var LineChart = require("react-chartjs").Line;
import chartOptions from "../helpers/ChartOptions";
import chartData from "../helpers/ChartData";
class Chart extends React.Component {
  constructor(props) {
    super(props);
    this.getChartTitle = this.getChartTitle.bind(this);
    this.minData = this.minData.bind(this);
    this.state = {
      viewAll: false,
      minData: this.minData(chartData(this.props.type, this.props.is_water)),
    };
  }

  getChartTitle() {
    switch (this.props.type) {
      case "abv":
        return "Alcohol (ABV)";
      case "calories":
        return "Calories (kcal/12oz)";
      case "real_degree_ferm":
        return "Real Deg. of Fermentation";
      case "app_degree_of_frem_ww":
        return "Apparent Deg. of Fermentation";
      case "p_original_extract_ww":
        return "Original Gravity (Plato)";
      case "spec_gravity_alcohol":
        return "Final Gravity (SG)";
      case "real_extract_ww":
        return "Real Extract (Plato)";
      case "app_extract_ww":
        return "Final Gravity (Plato)";
      case "color":
        return "Color Value (SRM)";
      case "ibu":
        return "IBU";
      case "sodium":
        return "Sodium";
      case "ph":
        return "pH";
      case "ph_water":
        return "pH";
      case "calcium":
        return "Calcium (ppm)";
      case "magnesium":
        return "Magnesium (ppm)	";
      case "bicarbonate":
        return "Bicarbonate (ppm)";
      case "chloride":
        return "Chloride (ppm)";
      case "potassium":
        return "Potassium (ppm)";
      case "sulfate":
        return "Sulfate (ppm)";
      case "zinc":
        return "Zinc (ppm)";
      case "acetic_acid":
        return "Acetic Acid (mg/L)";
      case "lactic_acid":
        return "Lactic Acid (ppm)";
      case "sulfur_dioxide":
        return "Sulfur Dioxide (ppm)";
      case "fan":
        return "FAN (ppm)";
      case "vdk":
        return "VDK (ppm)";
      case "acetaldehyde":
        return "Acetaldehyde (ppm)";
    }
  }

  minData(data) {
    const copy = JSON.parse(JSON.stringify(data));

    /*
    const newdata = [
      copy.datasets[0].data[0],
      copy.datasets[0].data.slice(-1)[0],
    ];

    const newlabels = [copy.labels[0], copy.labels.slice(-1)[0]];
    */

    const newdata = [];
    for (let i = 1; i <= 10 && i <= copy.datasets[0].data.length; i++) {
      newdata.unshift(copy.datasets[0].data.slice(-i)[0]);
    }

    const newlabels = [];
    for (let i = 1; i <= 10 && i <= copy.datasets[0].data.length; i++) {
      newlabels.unshift(copy.labels.slice(-i)[0]);
    }

    copy.datasets[0].data = newdata;
    copy.labels = newlabels;

    return copy;
  }

  get showButtonToViewData() {
    return !(
      this.copyData.labels.length === this.minData(this.copyData).labels.length
    );
  }

  get copyData() {
    let clone = JSON.parse(
      JSON.stringify(chartData(this.props.type, this.props.is_water))
    );

    return clone;
  }

  render() {
    return (
      <div className="text-center w100">
        <div className="dyn-chart">
          <div className={"w100 text-left chart-header"}>
            <div className="header">{this.getChartTitle()}</div>
          </div>

          {this.state.viewAll ? (
            <LineChart
              data={this.copyData}
              options={chartOptions}
              className="chart-canvas"
            />
          ) : (
            <LineChart
              data={this.minData(this.copyData)}
              options={chartOptions}
              className="chart-canvas"
            />
          )}

          {this.showButtonToViewData && (
            <button
              onClick={() => this.setState({ viewAll: !this.state.viewAll })}
            >
              View All Historical Data
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default Chart;
